import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import UmkSocialBar from "../unimake-social-bar/UmkSocialBar";

class UmkFooter extends Component {
	render() {
		return (
			<footer className="footer">
				<div className="footer-container">
					<div className="footer-items">
						<div className="footer-container-image">
							<img
								className="unimake-logo-footer"
								src={require("../../assets/img/unimakelogo.png")}
								alt="logo unimake"
								loading="lazy"
							/>
							<UmkSocialBar />
							<img
								className="apae-selo-footer"
								src={require("../../assets/img/apaeselo.webp")}
								alt="Empresa amiga APAE"
								loading="lazy"
							/>
						</div>

						<div className="footer-columns">
							<div>
								<p>
									<span className="umk-footer-titulo">Sobre</span>
								</p>
								<ul className="page-footer-list">
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<HashLink smooth to="/#sobre">Missão, Visão e Valores</HashLink>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/fale-conosco" target="_blank" rel="noopener noreferrer"> Seja um Unimaker</a>
									</li>
								</ul>
							</div>

							<div>
								<p>
									<span className="umk-footer-titulo">Soluções</span>
								</p>

								<ul className="page-footer-list">
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/geminibackup"> Gemini Backup</a>
									</li>
									
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/unidanfe"> UniDANFE</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/danfe-view" target="_blank" rel="noopener noreferrer"> DANFE View</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/uninfe" target="_blank" rel="noopener noreferrer"> UniNFe</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/e-bank"> E-Bank</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/certificados"> Certificados Digitais</a>
									</li>
									
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/bi"> Business Intelligence</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/wandreydescomplica"> Wandrey Descomplica</a>
									</li>
								</ul>
							</div>

							<div>
								<p>
									<span className="umk-footer-titulo">Nossos ERPS</span>
								</p>

								<ul className="page-footer-list">
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/mia"> MIA</a>
									</li>
									
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/unico-fecularia"> Agro</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/unico-auto"> Auto-Peças</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/unico-ferragens"> Ferragens</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/unico-material-eletrico">Materiais Elétricos</a>
									</li>

									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/unico-material-construcao">Materiais de Construção</a>
									</li>
								</ul>
							</div>

							<div>
								<p>
									<span className="umk-footer-titulo">LGPD</span>
								</p>

								<ul className="page-footer-list">
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<a href="https://inside.unimake.com.br/fale-conosco"> Fale conosco</a>
									</li>
									<li>
										<FontAwesomeIcon color="#FFFF" icon={faAngleRight} />
										<Link to={`${process.env.PUBLIC_URL}/lgpd?s=avisoprivacidade`}> Aviso de privacidade</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<hr />
					<div className="footer-copyright">
						<p>
							&copy; Copyright
							<script>document.write((new Date()).getFullYear())</script> -
							Unimake Software Todos os direitos reservados.
						</p>
					</div>
				</div>
			</footer>
		);
	}
}

export default UmkFooter;